export default __webpack_public_path__ + "static/media/illustration-study-2-m.c80cb6d5.webp";